import { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  MenuItem,
  Typography,
  Skeleton,
  Divider,
  FormGroup, FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
  ToggleButtonGroup,
  ToggleButton,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@material-ui/core';
import LoadingButton from '@material-ui/lab/LoadingButton';
import 'react-loading-skeleton/dist/skeleton.css'
import { InputField } from '../../input-field';
import { DateField } from '../../date-field';
import { decisions, moveConcernings } from '../../../static-data';
import { projectGetStakeholders } from '../../../api/project';
import { stakeholderGetAll } from '../../../api/stakeholder';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../store';
import { stakeholderPost, resetStakeholderStatus, updateField } from '../../../slices/stakeholderSlice';
import { useDeactivation } from 'src/hooks/use-deactivation';
import { DeactivateColumnControl } from 'src/components/deactivatable-field';
import { buildFieldKey } from 'src/utils/field-key';
import { deactivatableFieldIds } from 'src/config/field-registry';

interface WizardInfluencingProps {
  activeId: string;
}

export const WizardInfluencing: FC<WizardInfluencingProps> = (props) => {
  const { t } = useTranslation();
  const { activeId } = props;
  const [loadingRequest, setLoadingRequest] = useState(false);
  const { stakeholdersInfluencings } = useSelector((state: RootState) => state.stakeholder);
  const [stakeholders, setStakeholders] = useState([]);
  const [localeInfluencings, setLocaleInfluencings] = useState([]);
  const dispatch = useDispatch();

  // Field deactivation (Review 3 → stakeholders). A deactivated column disappears
  // (header + body cell); admins get an eye-off control on the header.
  const { isFieldKeyOff } = useDeactivation();
  const deactivatable = deactivatableFieldIds(3, 'stakeholders');
  const colKey = (id: string) => buildFieldKey(3, 'stakeholders', id);
  const isColOff = (id: string) => deactivatable.has(id) && isFieldKeyOff(colKey(id));

  const getLocaleInfluencings = () => {
    let newData = [];
    if (stakeholders && Array.isArray(stakeholders)) {
      stakeholders.forEach(s => {
        console.log("getLocaleInfluencings", s.id, activeId)
        console.log(stakeholdersInfluencings)
        if (s.id !== activeId) {
          let found = false;
          // Check if we have existing influence data for this stakeholder
          if (stakeholdersInfluencings && Array.isArray(stakeholdersInfluencings)) {
            stakeholdersInfluencings.forEach(inf => {
              if (s.id === inf.id) {
                console.log('Found existing influence data for:', s.id);
                newData.push({
                  id: s.id,
                  name: s.name,
                  influence: inf.influence || false,
                  influencingBy: inf.influencingBy || false
                })
                found = true
              }
            });
          }

          // If no existing data found, create default entry
          if (found === false) {
            newData.push({
              id: s.id,
              name: s.name,
              influence: false,
              influencingBy: false
            })
          }
        }
      });
    }
    setLocaleInfluencings(newData);
    console.log('new dataaaa', newData);
    dispatch(updateField({ parentField: 'stakeholdersInfluencings', field: null, value: newData }));
  }

  useEffect(() => {
    loadStakeholders();
  }, []);

  useEffect(() => {
    if (stakeholders.length > 0) {
      getLocaleInfluencings();
    }
  }, [stakeholders, activeId]);

  const loadStakeholders = async () => {
    try {
      const res = await stakeholderGetAll('name', 'asc', '', 1, 1000);
      if (res.items) {
        setStakeholders(res.items);
      }
    } catch (error) {
      console.error('Error loading stakeholders:', error);
    }
  };

  const handleUpdateInfluence = (event: React.ChangeEvent<HTMLInputElement>, stakeholder_id: any) => {
    console.log(event.target.checked, stakeholder_id);
    console.log(localeInfluencings);
    let newData = [];
    localeInfluencings.forEach(s => {
      if (s.id === stakeholder_id) {
        newData.push({
          id: s.id,
          name: s.name,
          influence: event.target.checked,
          influencingBy: s['influencingBy']
        })
      } else {
        newData.push({
          id: s.id,
          name: s.name,
          influence: s['influence'],
          influencingBy: s['influencingBy']
        })
      }
    });

    // formik.setFieldValue('influencings', newData)
    setLocaleInfluencings(newData);
    dispatch(updateField({ parentField: 'stakeholdersInfluencings', field: null, value: newData }));
  }

  const handleUpdateInfluencingBy = (event: React.ChangeEvent<HTMLInputElement>, stakeholder_id: any) => {
    console.log(event.target.checked, stakeholder_id);
    console.log(localeInfluencings);
    let newData = [];
    localeInfluencings.forEach(s => {
      if (s.id === stakeholder_id) {
        newData.push({
          id: s.id,
          name: s.name,
          influence: s['influence'],
          influencingBy: event.target.checked
        })
      } else {
        newData.push({
          id: s.id,
          name: s.name,
          influence: s['influence'],
          influencingBy: s['influencingBy']
        })
      }
    });

    // formik.setFieldValue('influencings', newData)
    setLocaleInfluencings(newData);
    dispatch(updateField({ parentField: 'stakeholdersInfluencings', field: null, value: newData }));
  }

  return (
    <Card
      // variant="outlined"
      sx={{ backgroundColor: 'background.default' }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            xs={12}
          >
            <div>
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                >
                  {/* <Typography
                      variant='subtitle1'
                    >
                      {t('influencing_by')}
                    </Typography> */}

                  {/* Stakeholders */}
                  <Grid container>
                    <TableContainer sx={{ borderRadius: '8px', boxShadow: 7, }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t('this_stakeholder')}</TableCell>
                            {!isColOff('influence') && (
                              <TableCell>
                                {t('influencing_who')}
                                {deactivatable.has('influence') && <DeactivateColumnControl fieldKey={colKey('influence')} />}
                              </TableCell>
                            )}
                            {!isColOff('influencingBy') && (
                              <TableCell>
                                {t('influencing_by')}
                                {deactivatable.has('influencingBy') && <DeactivateColumnControl fieldKey={colKey('influencingBy')} />}
                              </TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {localeInfluencings?.map((s) => (
                            <TableRow
                              hover
                              key={s.id}
                            >
                              <TableCell>
                                <b>{s.name}</b>
                              </TableCell>
                              {!isColOff('influence') && (
                                <TableCell>
                                  <Checkbox
                                    checked={s.influence}
                                    onChange={(e) => handleUpdateInfluence(e, s.id)}
                                    sx={{ py: 0 }}
                                  />
                                </TableCell>
                              )}
                              {!isColOff('influencingBy') && (
                                <TableCell>
                                  <Checkbox
                                    checked={s.influencingBy}
                                    onChange={(e) => handleUpdateInfluencingBy(e, s.id)}
                                    sx={{ py: 0 }}
                                  />
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                </Grid>

                {/* {formik.errors.submit && (
                    <Grid
                      item
                      xs={12}
                    >
                      <FormHelperText error>
                        {formik.errors.submit}
                      </FormHelperText>
                    </Grid>
                  )} */}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

WizardInfluencing.propTypes = {
  activeId: PropTypes.string,
};